import { put, select, takeEvery } from 'redux-saga/effects'
import { PatientDemographicsConstants } from '../../../patientDemographics/store/patientDemographics.constants'
import { throwPcrException } from '../../../pcr/store/pcr.actions'
import { getPatientDemographicsSelector } from '../../../patientDemographics/selectors'
import { getAge } from '../../../../utilities/showAssessmentAirwayFields.util'
import { saveInitialAssessmentAirway, setLengthBasedTapeMeasure } from '../store/airway.actions'
import { IPatientDemographicsState } from '../../../patientDemographics/store/patientDemographics.types'
import { performWithMutexHOG } from '../../../../services/mutexUtility.service'

export function* resetLengthBasedTapeMeasure() {
  try {
    const patientDemographics: IPatientDemographicsState = yield select(getPatientDemographicsSelector)
    const { age, ageUnit } = patientDemographics
    const resetLengthBasedTapeMeasured =
      Number(age) >= 1 && ageUnit?.id && getAge(Number(age), ageUnit?.id?.toString()) <= 13 ? false : true
    if (resetLengthBasedTapeMeasured) {
      yield put(setLengthBasedTapeMeasure(null))
      yield put(saveInitialAssessmentAirway())
    }
  } catch (e) {
    yield put(throwPcrException(`resetLengthBasedTapeMeasure() error: ${e}`))
  }
}
export function* resetLengthBasedTapeMeasureSaga() {
  yield takeEvery(
    [PatientDemographicsConstants.SET_AGE, PatientDemographicsConstants.SET_AGE_UNIT],
    performWithMutexHOG,
    resetLengthBasedTapeMeasure
  )
}
